<template>
  <div class="question-container">
    <p class="question-index">{{ heading }}</p>

    <div class="question-toolbar">
      <div class="question-box" :class="{ 'question-type-expanded': isExpanded }">
        <SurveyIcon :type="type.icon" />
        <p>{{ type.title }}</p>
        <button class="select-question" @click="handleSelect">
          <svg v-if="isExpanded" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3.72651 2.96464L3.69115 2.92929L3.6558 2.96464L2.96464 3.6558L2.92929 3.69115L2.96464 3.72651L11.2381 12L2.96464 20.2735L2.92929 20.3088L2.96464 20.3442L3.6558 21.0354L3.69115 21.0707L3.72651 21.0354L12 12.7619L20.2735 21.0354L20.3088 21.0707L20.3442 21.0354L21.0354 20.3442L21.0707 20.3088L21.0354 20.2735L12.7619 12L21.0354 3.72651L21.0707 3.69115L21.0354 3.6558L20.3442 2.96464L20.3088 2.92929L20.2735 2.96464L12 11.2381L3.72651 2.96464Z" fill="#111111" stroke="#111111" stroke-width="0.1"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M16.8322 4.52694V4.52741H16.8323H16.8323H16.8324H16.8325H16.8326H16.8326H16.8327H16.8328H16.8328H16.8329H16.833H16.8331H16.8331H16.8332H16.8333H16.8333H16.8334H16.8335H16.8336H16.8336H16.8337H16.8338H16.8338H16.8339H16.834H16.8341H16.8341H16.8342H16.8343H16.8344H16.8344H16.8345H16.8346H16.8346H16.8347H16.8348H16.8349H16.8349H16.835H16.8351H16.8351H16.8352H16.8353H16.8354H16.8354H16.8355H16.8356H16.8356H16.8357H16.8358H16.8359H16.8359H16.836H16.8361H16.8361H16.8362H16.8363H16.8364H16.8364H16.8365H16.8366H16.8366H16.8367H16.8368H16.8369H16.8369H16.837H16.8371H16.8371H16.8372H16.8373H16.8374H16.8374H16.8375H16.8376H16.8376H16.8377H16.8378H16.8379H16.8379H16.838H16.8381H16.8381H16.8382H16.8383H16.8384H16.8384H16.8385H16.8386H16.8387H16.8387H16.8388H16.8389H16.8389H16.839H16.8391H16.8392H16.8392H16.8393H16.8394H16.8394H16.8395H16.8396H16.8397H16.8397H16.8398H16.8399H16.8399H16.84H16.8401H16.8402H16.8402H16.8403H16.8404H16.8404H16.8405H16.8406H16.8407H16.8407H16.8408H16.8409H16.8409H16.841H16.8411H16.8412H16.8412H16.8413H16.8414H16.8414H16.8415H16.8416H16.8417H16.8417H16.8418H16.8419H16.8419H16.842H16.8421H16.8422H16.8422H16.8423H16.8424H16.8424H16.8425H16.8426H16.8427H16.8427H16.8428H16.8429H16.8429H16.843H16.8431H16.8432H16.8432H16.8433H16.8434H16.8435H16.8435H16.8436H16.8437H16.8437H16.8438H16.8439H16.844H16.844H16.8441H16.8442H16.8442H16.8443H16.8444H16.8445H16.8445H16.8446H16.8447H16.8447H16.8448H16.8449H16.845H16.845H16.8451H16.8452H16.8452H16.8453H16.8454H16.8455H16.8455H16.8456H16.8457H16.8457H16.8458H16.8459H16.846H16.846H16.8461H16.8462H16.8462H16.8463H16.8464H16.8465H16.8465H16.8466H16.8467H16.8467H16.8468H16.8469H16.847H16.847H16.8471H16.8472H16.8472H16.8473H16.8474H16.8475H16.8475H16.8476H16.8477H16.8477H16.8478H16.8479H16.848H16.848H16.8481H16.8482H16.8483H16.8483H16.8484H16.8485H16.8485H16.8486H16.8487H16.8488H16.8488H16.8489H16.849H16.849H16.8491H16.8492H16.8493H16.8493H16.8494H16.8495H16.8495H16.8496H16.8497H16.8498H16.8498H16.8499H16.85H16.85H16.8501H16.8502H16.8503H16.8503H16.8504H16.8505H16.8505H16.8506H16.8507H16.8508H16.8508H16.8509H16.851H16.851H16.8511H16.8512H16.8513H16.8513H16.8514H16.8515H16.8515H16.8516H16.8517H16.8518H16.8518H16.8519H16.852H16.852H16.8521H16.8522H16.8523H16.8523H16.8524H16.8525H16.8526H16.8526H16.8527H16.8528H16.8528H16.8529H16.853H16.8531H16.8531H16.8532H16.8533H16.8533H16.8534H16.8535H16.8536H16.8536H16.8537H16.8538H16.8538H16.8539H16.854H16.8541H16.8541H16.8542H16.8543H16.8543H16.8544H16.8545H16.8546H16.8546H16.8547H16.8548H16.8548H16.8549H16.855H16.8551H16.8551H16.8552H16.8553H16.8553H16.8554H16.8555H16.8556H16.8556H16.8557H16.8558H16.8558H16.8559H16.856H16.8561H16.8561H16.8562H16.8563H16.8563H16.8564H16.8565H16.8566H16.8566H16.8567H16.8568H16.8568H16.8569H16.857H16.8571H16.8571H16.8572H16.8573H16.8574H16.8574H16.8575H16.8576H16.8576H16.8577H16.8578H16.8579H16.8579H16.858H16.8581H16.8581H16.8582H16.8583H16.8584H16.8584H16.8585H16.8586H16.8586H16.8587H16.8588H16.8589H16.8589H16.859H16.8591H16.8591H16.8592H16.8593H16.8594H16.8594H16.8595H16.8596H16.8596H16.8597H16.8598H16.8599H16.8599H16.86H16.8601H16.8601H16.8602H16.8603H16.8604H16.8604H16.8605H16.8606H16.8606H16.8607H16.8608H16.8609H16.8609H16.861H16.8611H16.8611H16.8612H16.8613H16.8614H16.8614H16.8615H16.8616H16.8616H16.8617H16.8618H16.8619H16.8619H16.862H16.8621H16.8622H16.8622H16.8623H16.8624H16.8624H16.8625H16.8626H16.8627H16.8627H16.8628H16.8629H16.8629H16.863H16.8631H16.8632H16.8632H16.8633H16.8634H16.8634H16.8635H16.8636H16.8637H16.8637H16.8638H16.8639H16.8639H16.864H16.8641H16.8642H16.8642H16.8643H16.8644H16.8644H16.8645H16.8646H16.8647H16.8647H16.8648H16.8649H16.8649H16.865H16.8651H16.8652H16.8652H16.8653H16.8654H16.8654H16.8655H16.8656H16.8657H16.8657H16.8658H16.8659H16.8659H16.866H16.8661H16.8662H16.8662H16.8663H16.8664H16.8665H16.8665H16.8666H16.8667H16.8667H16.8668H16.8669H16.867H16.867H16.8671H16.8672H16.8672H16.8673H16.8674H16.8675H16.8675H16.8676H16.8677H16.8677H16.8678H16.8679H16.868H16.868H16.8681H16.8682H16.8682H16.8683H16.8684H16.8685H16.8685H16.8686H16.8687H16.8687H16.8688H16.8689V4.57741C17.0324 4.56824 17.1838 4.66148 17.2495 4.81127C17.3152 4.96107 17.2801 5.13684 17.1624 5.24995L16.8322 4.52694ZM16.8322 4.52694L16.8254 4.52788C16.7251 4.54171 16.6325 4.59156 16.5639 4.66497L3.87265 17.3684C3.81609 17.4201 3.7735 17.4869 3.7496 17.5603L3.74953 17.5603L3.74884 17.5629L2.96624 20.4976L2.96618 20.4979C2.92647 20.6498 2.97143 20.8102 3.08161 20.9203C3.19179 21.0305 3.35214 21.0755 3.50409 21.0358L3.50433 21.0357L6.43905 20.2531L6.43907 20.2532L6.44165 20.2523C6.51505 20.2285 6.58182 20.1859 6.63353 20.1293L19.3371 7.43796C19.3372 7.4379 19.3372 7.43783 19.3373 7.43776C19.5132 7.26683 19.5144 6.98617 19.3443 6.81088C19.1733 6.6348 18.8925 6.63352 18.7172 6.80371L18.7166 6.80424L6.12047 19.4004L4.60154 17.8815L17.197 5.286C17.1971 5.28588 17.1973 5.28577 17.1974 5.28565L16.8322 4.52694ZM17.396 3.84506L17.3607 3.88042L17.396 3.91577L20.0862 6.60593L20.1058 6.58631C20.1163 6.59745 20.1323 6.60598 20.1568 6.60601L20.1569 6.60595L20.1569 6.6059L20.1571 6.60577L20.1577 6.60515L20.1602 6.60261L20.1701 6.59271L20.1923 6.57059L20.2059 6.5569L20.3153 6.44754L20.4249 6.3379L20.4611 6.30173L20.4712 6.29159L20.4739 6.28892L20.4746 6.28824L20.4748 6.28806L20.4748 6.28802L20.4748 6.28801L20.4395 6.25265L20.4748 6.28801C21.2388 5.52407 21.2372 4.28948 20.4748 3.52713L20.4747 3.52706C20.0924 3.14625 19.5951 2.95 19.0944 2.95C18.5937 2.95 18.0949 3.14621 17.7139 3.52713L17.396 3.84506Z" fill="#111111" stroke="#111111" stroke-width="0.1"/>
          </svg>
        </button>
      </div>
      <button
        class="question-button"
        :class="{ 'question-button-disabled': !removable }"
        :disabled="!removable"
        @click="handleDelete"
      >
        <SurveyIcon :type="'delete'" />
      </button>
    </div>

    <div v-if="isExpanded" class="question-content">
      <div class="question-box question-input">
        <label for="question-label">Question title</label>
        <input type="text" id="question-label" :value="question.label" @input="handleChange({ label: $event.target.value })" />
      </div>

      <div v-if="hasOptions" class="question-options">
        <div v-for="(option, index) in question.options" :key="index" class="question-option">
          <div class="question-box question-input">
            <label :for="'question-option-label-' + index">Option {{ index + 1 }}</label>
            <input type="text" :id="'question-option-label-' + index" :value="question.options[index]" @input="handleChangeOption(index, $event.target.value)" />
          </div>
          <button class="question-button" @click="handleDeleteOption(index)">
            <SurveyIcon :type="'delete'" />
          </button>
          <div class="question-option-order">
            <button v-if="index > 0" class="question-button" @click="handleMoveOption(index, index - 1)">
              <SurveyIcon :type="'move-up'" />
            </button>
            <button v-if="index < question.options.length - 1" class="question-button" @click="handleMoveOption(index, index + 1)">
              <SurveyIcon :type="'move-down'" />
            </button>
          </div>
        </div>
      </div>

      <div class="question-settings">
        <button v-if="hasOptions" class="button-yellow add-question-option" @click="handleAddOption">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M7.625 2.45H7.575V2.5V8.075H2H1.95V8.125V8.875V8.925H2H7.575V14.5V14.55H7.625H8.375H8.425V14.5V8.925H14H14.05V8.875V8.125V8.075H14H8.425V2.5V2.45H8.375H7.625Z" fill="#EA7801" stroke="#EA7801" stroke-width="0.1"/>
          </svg>
          Add option
        </button>
        <div class="question-settings-right">
          <InputField v-if="getQuestionType(question).title === 'Text'"
            inputType="toggle"
            :label="'Text area'"
            :modelValue="question.textarea"
            @inputClick="handleChange({ textarea: !question.textarea })" />
          <InputField inputType="toggle"
            :label="'Required'"
            :modelValue="question.required"
            @inputClick="handleChange({ required: !question.required })" />
        </div>
      </div>

      <div v-if="showSliderOptions" class="question-box question-input">
        <label for="slider-min">Lower value</label>
        <input type="number" id="slider-min" :value="question.slider_options.options.min ?? 1" @input="handleChangeSliderOptions({ min: $event.target.value })" />
      </div>
      <div v-if="showSliderOptions" class="question-box question-input">
        <label for="slider-max">Upper value</label>
        <input type="number" id="slider-max" :value="question.slider_options.options.max ?? 10" @input="handleChangeSliderOptions({ max: $event.target.value })" />
      </div>

    </div>
  </div>
</template>

<script>
import InputField from '../InputField/InputField.vue';
import SurveyIcon from './SurveyIcon.vue';

export default {
  name: 'SurveyQuestion',
  components: { SurveyIcon, InputField },
  props: {
    number: {
      type: Number,
    },
    label: {
      type: String
    },
    question: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: undefined,
    },
    removable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      expanded: this.question._id ? false : true,
    }
  },
  computed: {
    isExpanded() {
      return this.selected ?? this.expanded;
    },
    heading() {
      return this.label?.length > 0
        ? this.label
        : typeof this.number !== 'undefined'
          ? `Question ${this.number}`
          : 'Question';
    },
    hasOptions() {
      return (this.question.radio || this.question.checkbox);
    },
    showSliderOptions() {
      return this.question.slider;
    },
    type() {
      return this.getQuestionType(this.question);
    },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', { ...this.question, ...change });
    },
    handleDelete() {
      this.$emit('delete');
    },
    handleSelect() {
      this.$emit('select', !this.isExpanded);
      this.expanded = !this.isExpanded;
    },
    handleAddOption() {
      this.handleChange({
        options: this.question.options.concat(['']),
      });
    },
    handleChangeOption(index, value) {
      const options = [...this.question.options];
      options[index] = value;
      this.handleChange({ options });
    },
    handleChangeSliderOptions(change) {
      this.handleChange({
        slider_options: {
          ...this.question.slider_options,
          options: {
            ...this.question.slider_options?.options,
            ...change,
          }
        }
      });
    },
    handleDeleteOption(index) {
      const options = [...this.question.options];
      options.splice(index, 1);
      this.handleChange({ options });
    },
    handleMoveOption(index, newIndex) {
      const options = [...this.question.options];
      const option = options.splice(index, 1).pop();
      options.splice(newIndex, 0, option);
      this.handleChange({ options });
    },
    getQuestionType(question) {
      /**
        id: String,
        label: String,
        model: String,
        date: Boolean,
        checkbox: Boolean,
        radio: Boolean,
        slider: Boolean,
        textarea: Boolean,
        upload: Boolean,
        maxsize: Number,
        other: Boolean,
        slider_options: {
          options: Object,
          show_value: Boolean,
          media: [
            {
              file: String,
              fileType: String,
            },
          ],
          fe_media: [
            {
              file: String,
              fileType: String,
            },
          ],
        },
        options: [String],
        helper: String,
        validator: String,
        required: Boolean,
       */

      // if (question.date)
      //   return {
      //     title: 'Date',
      //     icon: 'single-choice'
      //   }
      if (question.radio)
        return {
          title: 'Single choice',
          icon: 'radio'
        }
      else if (question.checkbox)
        return {
          title: 'Multiple choice',
          icon: 'checkbox'
        }
      else if (question.slider)
        return {
          title: 'Slider',
          icon: 'slider',
        }
      else if (question.upload)
        return {
          title: 'Image',
          icon: 'image',
        }
      return {
        title: 'Text',
        icon: 'text'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  display: flex;
  flex-direction: column;

  .question-box {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #333;
    background-color: #FFF;

    p {
      flex: 1;
      font-size: 16px;
      font-weight: 400;
      line-height: 22.4px;
      text-align: left;
    }
  }

  .question-button {
    padding: 0;
    border: 0;
    background-color: transparent;
  }

  .question-button-disabled {
    opacity: 0.25;
  }

  .question-index {
    margin: 0 0 8px 0;

    font-size: 16px;
    font-weight: 500;
    font-family: 'CircularXXWeb-Medium';
    line-height: 22.4px;
    text-align: left;
    color: #333;
  }

  .question-type-expanded {
    background-color: #F2F2F2;
  }
  .select-question {
    padding: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
  }

  .question-toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .question-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  .question-input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    width: 100%;
    padding: 8px 16px;

    label {
      margin: 0;
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.024px;
      color: #999;
    }

    input {
      align-self: stretch;
      padding: 0;
      border: none;
      font-size: 16px;
      font-weight: 400;
      line-height: 22.4px;
      text-align: left;
    }

    input:focus, textarea:focus {
      outline: none;
    }
  }

  .question-settings {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;

    .add-question-option {
      gap: 4px;
      padding: 0;
      font-size: 14px;
    }

    .question-settings-right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
    }
  }

  .question-options {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;

    .question-option {
      display: flex;
      align-items: center;
      gap: 4px;
      align-self: stretch;

      .question-option-order {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
